export default {
    name: 'surface',
    components: {

    },
    data () {
        return {
            activeIndex:1,
        }
    },
    methods: {
        
    },
    created () {

    }
  }
  


// WEBPACK FOOTER //
// ./src/views/surface/script.js